import PropTypes from 'prop-types';
import React from 'react';

import { NavigationPageWrapper, NavigationButton } from '$partials/navigation/index.js';
import Footer from '$partials/global/footer';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ErrorPage = (props) => {
    const status = props.err?.status || 500;

    const page = props?.data?.page;
    let message = '';

    switch(status) {
    case 404:
        message = '404 - Page not found.';
        break;

    default:
        message = 'Sorry, something went wrong.';
    }

    const title = page?.title || message;

    return (
        <NavigationPageWrapper {...props.data?.navigation}>
            <main id='main-content'>
                <div className='h-[100dvh]'>
                    <header className='rounded flex flex-col gap-32 sm:gap-60 md:gap-80 px-layout-item pt-20 pb-[200px] sm:pt-34 md:pt-30 lg:pt-40 bg-foreground mb-1'>
                        <a
                            className='flex flex-col'
                            href={'/'}>
                            <span>Bureau for</span>
                            <span>Visual Affairs</span>
                        </a>

                        <h1 className='type-style-hero-sm sm:mr-60'>
                            {title}
                        </h1>

                        <NavigationButton />
                    </header>

                    <Footer {...props?.data?.footer} />
                </div>
            </main>
        </NavigationPageWrapper>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

const propTypes = {
    data: PropTypes.object,
    err: PropTypes.object
};

ErrorPage.propTypes = propTypes;

export default ErrorPage;
